<template>
  <div>
    <div v-if="transaction">
      <!-- {{ transaction }} -->
      <transaction-chat :id="transaction.id" />
      <div v-if="!done">
        <button @click="edit" class="btn btn-info btn-icon mw mb-4">
          {{ "edit" | setText("Редактировать заказ") }}
        </button>
      </div>
      <div class="border text-center">
        <div>
          <h4>
            {{ "wait_partner" | setText("Ожидайте готовность партнера") }}
          </h4>

          <h3 class="text-info">
            {{ "status" | setText("Статус") }}: {{ transaction.display_status }}
          </h3>

          <h4 v-if="timer > 0" class="text-info">
            {{ "wait_60_second" | setText("Ожидайте: ") }} {{ timer }}
            {{ "second" | setText("сек.") }}
          </h4>

          <button v-else @click="refresh" class="btn btn-icon mw">
            <span class="ti-reload"></span>
            {{ "check_change" | setText("Проверить изменения") }}
          </button>
        </div>
      </div>
      <div
        :class="`border text-center ${
          transaction.status == 1 && !done ? '' : 'opacity'
        }`"
      >
        <h4>
          {{ "wait_limit" | setText("Ожидание лимита и итоговую стоимость") }}
          <span class="ti-timer"></span>
        </h4>

        <h3 class="text-info">
          {{ "status" | setText("Статус") }}: {{ transaction.display_status }}
        </h3>
  
        <h2 class="text-danger" v-if="transaction.limit_verdict">
          {{ transaction.limit_verdict }}
        </h2>

        <div class="mt-4">
          <h4 v-if="timer > 0" class="text-info">
            {{ "wait_60_second" | setText("Ожидайте: ") }} {{ timer }}
            {{ "second" | setText("сек.") }}
          </h4>

          <button v-else @click="refresh" class="btn btn-icon mw">
            <span class="ti-reload"></span>
            {{ "check" | setText("Проверить") }}
          </button>
        </div>

        <div
          v-if="
            transaction.limit &&
            transaction.price &&
            transaction.price_per_month
          "
        >
          <div v-if="transaction.limit">
            <h3 class="text-success">
              {{ "your_limit" | setText("Ваш лимит") }}:
              {{ transaction.limit | spaceBetweenNumber }} UZS
            </h3>
          </div>
          <div v-if="transaction.price">
            <h5>
              {{ "price_partner" | setText("Общая стоимость") }}:
              {{ transaction.price | spaceBetweenNumber }} UZS
            </h5>
          </div>
          <div v-if="transaction.price_per_month">
            <h4>
              {{ "price_partner_mo" | setText("Стоимость в месяц") }}
              {{ transaction.month }} {{ "mo" | setText }}:
              <span class="link"> {{ transaction.price_per_month | spaceBetweenNumber }} UZS /
              {{ "mo" | setText }}</span>
            </h4>
          </div>

          <div v-if="!transaction.client_confirmed">
            <div v-if="order.price_total <= transaction.limit">
              <h3 class="mt-2">
                {{
                  "client_apply"
                    | setText(
                      "Если клиент согласен на условия лимита, нажмите - Клиент согласен на условия"
                    )
                }}
              </h3>
              <button
                @click="clientConfirmed()"
                class="btn btn-info btn-icon mw mt-4"
              >
                {{ "client_apply" | setText("Клиент согласен на условия") }}
              </button>
            </div>

            <div v-else>
              <h3 class="text-danger">
                {{
                  "no_limit_sorry" | setText("Извините, недостаточно лимита")
                }}
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="`border text-center ${
          transaction.client_confirmed && !done ? '' : 'opacity'
        }`"
      >
        <h4>
          {{ "wait_order" | setText("Ожидание договора") }}
          <span class="ti-timer"></span>
        </h4>

        <div>
          <a
            v-if="transaction.act_original"
            target="_blank"
            class="btn btn-success mw mb-4"
            :href="transaction.act_original"
            >{{ "download" | setText("Скачать") }}</a
          >
        </div>

        <h4 v-if="timer > 0" class="text-info">
          {{ "wait_60_second" | setText("Ожидайте: ") }} {{ timer }}
          {{ "second" | setText("сек.") }}
        </h4>

        <button v-else @click="refresh" class="btn btn-icon mw">
          <span class="ti-reload"></span>
          {{ "check" | setText("Проверить") }}
        </button>
      </div>

      <div class="border text-center" v-if="transaction.is_sms">
        <h4>
          {{ "wait_sms" | setText("Отправить смс партнеру от клиента") }}
        </h4>
        <h5 v-if="transaction.code" class="text-success">
          {{ "sent" | setText("Отправлено") }}: {{ transaction.code }}
        </h5>
        <fg-input
          :type="`text`"
          :label="`Код из смс`"
          :labelKey="`sms_code`"
          v-model="sms"
        ></fg-input>
        <button @click="send" class="btn btn-info mw">
          {{ "send_sms_partner" | setText("Отправить смс партнеру") }}
        </button>
      </div>

      <div
        :class="`border text-center ${
          transaction.act_original && !done ? '' : 'opacity'
        }`"
      >
        <h4>
          {{ "upload_act" | setText("Загрузка подписанного договора") }}
          <span class="ti-upload"></span>
        </h4>
        <zip-upload
          v-model="sign"
          :title="'Выберите PNG/JPG/PDF'"
          @input="uploadSign"
        />

        <a
          v-if="transaction.act"
          target="_blank"
          class="btn btn-success mw"
          :href="transaction.act"
          >{{ "download_check" | setText("Скачать, проверить") }}</a
        >
      </div>
      <div :class="`border text-center `">
        <h4>
          {{ "status" | setText() }}
          <span class="ti-info"></span>
        </h4>

        <h3 v-if="done" class="text-success">
          {{
            "order_done"
              | setText("Заказ выполнен, клиент может забрать устройство")
          }}
        </h3>

        <div v-else>
          <h3 class="text-danger">
            {{ "proccessing" | setText("Процесс формирования") }}
          </h3>

          <h4 v-if="timer > 0" class="text-info">
            {{ "wait_60_second" | setText("Ожидайте: ") }} {{ timer }}
            {{ "second" | setText("сек.") }}
          </h4>

          <button v-else @click="refresh" class="btn btn-icon mw">
            <span class="ti-reload"></span>
            {{ "check" | setText("Проверить") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";

export default {
  computed: {
    done() {
      return (
        this.transaction &&
        this.transaction.system_confirmed &&
        this.transaction.client_confirmed
      );
    },
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  mounted() {
    setInterval(() => {
      this.timer--;
    }, 1000);
  },
  name: "filter",
  methods: {
    uploadSign(val) {
      this.createTransaction({
        akt: val,
      });
    },
    edit() {
      this.$emit("setStep", "add_user");
    },
    send() {
      if (!this.sms) {
        this.$notify({
          title: `!!!`,
          message: "Введите код из смс",
          icon: "ti-close",
          horizontalAlign: "right",
          verticalAlign: "top",
        });
        return false;
      }
      this.createTransaction({
        code: this.sms,
      });
      setTimeout(() => {
        this.sms = "";
      });

      logger(this.$http, {
        name: `Отправка смс`,
        description: this.sms,
        model_type: "order",
        model_id: this.order.id,
      });
    },
    clientConfirmed() {
      this.createTransaction({
        client_confirmed: 1,
      });

      logger(this.$http, {
        name: `Клиент подтвердил условия`,
        description: this.transaction.price_per_month,
        model_type: "order",
        model_id: this.order.id,
      });
    },
    refresh() {
      this.timer = 10;
      this.createTransaction({
        step: "processing",
      });
    },
  },
  data() {
    return {
      sms: null,
      timer: 0,
      sign: null,
    };
  },
};
</script>

